import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import store from "./state/store";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import ClipboardContext from "./components/providers/Clipboard";
import { GAProvider } from "@connectaryal/google-analytics";

/* global document, module, require */

const title = "Gridd";

const rootElement = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

let slideId = "unknown";

root?.render(
  <GAProvider config={{ measurementId: "NONE" }}>
    <ReduxProvider store={store}>
      <ClipboardContext>
        <FluentProvider theme={webLightTheme} style={{ height: "100%" }}>
          <Router>
            <App title={title} slideId={slideId} />
          </Router>
        </FluentProvider>
      </ClipboardContext>
    </ReduxProvider>
  </GAProvider>
);

if (module.hot) {
  module.hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
